import React, { useEffect, useState } from "react"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
// import "../../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"
// import "../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"


import axios from "axios"
import { useParams } from "react-router-dom"
import configure from "configure"
import moment from "moment/moment"
import PunchScreen from "./Punch Details/PunchScreen"
import LeaveManagement from "./LeaveManagement/LeaveManagement"
import SalarySheet from "./SalarySheet/SalarySheet"


const PayrollManagement = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [fixedSideTab, setFixedSideTab] = useState(false)

  document.addEventListener("scroll", () => {
    if (window.scrollY > 68) {
      setFixedSideTab(true)
    } else {
      setFixedSideTab(false)
    }
  })

  document.title = "Payroll Management | Zithas Technologies"

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }


  return (
    <React.Fragment>
   
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Payroll Management"} />

          <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="2" className="px-0">
              <Nav
                pills
                className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? "fixed-side-tab" : ""} h-100`}
              >
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                   Punch Details
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                   Leave Management
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3")
                    }}
                  >
                   Salary Sheet
                  </NavLink>
                </NavItem>
             
                
              </Nav>
            </Col>
            <Col md="10 pe-0">
              <div className=" bg-transparent mb-0" id="edit-lead">
             
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <PunchScreen
                    />
                  </TabPane>
                  <TabPane tabId="2">
                    <LeaveManagement
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <SalarySheet />
                  </TabPane>
   
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
  // return(
  //   <>
  //       <div className="sidebar close">
  //       <div className="logo-details">
  //         <i className="bx bxl-c-plus-plus" />
  //         <span className="logo_name">CodingLab</span>
  //       </div>
  //       <ul className="nav-links">
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-grid-alt" />
  //             <span className="link_name">Dashboard</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Category
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <div className="iocn-link">
  //             <a href="#">
  //               <i className="bx bx-collection" />
  //               <span className="link_name">Category</span>
  //             </a>
  //             <i className="bx bxs-chevron-down arrow" />
  //           </div>
  //           <ul className="sub-menu">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Category
  //               </a>
  //             </li>
  //             <li>
  //               <a href="#">HTML &amp; CSS</a>
  //             </li>
  //             <li>
  //               <a href="#">JavaScript</a>
  //             </li>
  //             <li>
  //               <a href="#">PHP &amp; MySQL</a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <div className="iocn-link">
  //             <a href="#">
  //               <i className="bx bx-book-alt" />
  //               <span className="link_name">Posts</span>
  //             </a>
  //             <i className="bx bxs-chevron-down arrow" />
  //           </div>
  //           <ul className="sub-menu">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Posts
  //               </a>
  //             </li>
  //             <li>
  //               <a href="#">Web Design</a>
  //             </li>
  //             <li>
  //               <a href="#">Login Form</a>
  //             </li>
  //             <li>
  //               <a href="#">Card Design</a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-pie-chart-alt-2" />
  //             <span className="link_name">Analytics</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Analytics
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-line-chart" />
  //             <span className="link_name">Chart</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Chart
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <div className="iocn-link">
  //             <a href="#">
  //               <i className="bx bx-plug" />
  //               <span className="link_name">Plugins</span>
  //             </a>
  //             <i className="bx bxs-chevron-down arrow" />
  //           </div>
  //           <ul className="sub-menu">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Plugins
  //               </a>
  //             </li>
  //             <li>
  //               <a href="#">UI Face</a>
  //             </li>
  //             <li>
  //               <a href="#">Pigments</a>
  //             </li>
  //             <li>
  //               <a href="#">Box Icons</a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-compass" />
  //             <span className="link_name">Explore</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Explore
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-history" />
  //             <span className="link_name">History</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 History
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <a href="#">
  //             <i className="bx bx-cog" />
  //             <span className="link_name">Setting</span>
  //           </a>
  //           <ul className="sub-menu blank">
  //             <li>
  //               <a className="link_name" href="#">
  //                 Setting
  //               </a>
  //             </li>
  //           </ul>
  //         </li>
  //         <li>
  //           <div className="profile-details">
  //             <div className="profile-content">
  //               {/*<img src="image/profile.jpg" alt="profileImg">*/}
  //             </div>
  //             <div className="name-job">
  //               <div className="profile_name">Prem Shahi</div>
  //               <div className="job">Web Desginer</div>
  //             </div>
  //             <i className="bx bx-log-out" />
  //           </div>
  //         </li>
  //       </ul>
  //     </div>
  //     <section className="home-section">
  //       <div className="home-content">
  //         <i className="bx bx-menu" />
  //         <span className="text">Drop Down Sidebar</span>
  //       </div>
  //     </section>
  //     <div className="one" />
  //   </>
  // )
}

export default PayrollManagement

